module.exports = __webpack_public_path__ + "img/empty-organization.24aa4aef.svg";